import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ClientsBar from './ClientsBar';
import Chatbot from './Chatbot';
import { Box } from '@mui/material';

const Layout = () => {
  return (
    <Box className="min-h-screen flex flex-col">
      <Header />
      <Box component="main" className="flex-grow" sx={{ pt: { xs: '48px', sm: '56px' } }}> {/* Adjust padding for fixed header */}
        <Outlet /> {/* Page content will be rendered here */}
      </Box>
      <ClientsBar />
      <Footer />
      <Chatbot />
    </Box>
  );
};
export default Layout;
